<div class="container d-flex direction-column justify-center" [class.container--modern]="appearance === 'modern'">
  <div class="modern-skeleton-block" *ngIf="appearance === 'modern' && isLoading">
    <app-skeleton variant="card" [lines]="4"></app-skeleton>
    <app-skeleton variant="table-row" [rows]="6" [columns]="9"></app-skeleton>
  </div>

  <ng-container *ngIf="!(appearance === 'modern' && isLoading)">
  <ng-container *ngIf="lote?.IntegrationError">
    <div class="content-return">
      <span><strong>Retorno: </strong>{{ lote?.IntegrationMsg || "-" }}</span>
    </div>
  </ng-container>
  <div class="content-lots">
    <app-detalhes-lotes-card
      [lote]="lote"
      [typeDetail]="typeDetailLot"
      [appearance]="appearance"
    ></app-detalhes-lotes-card>
  </div>

  <div class="annex" [class.annex--modern-row]="appearance === 'modern'" *ngIf="showAnnexes() || appearance === 'modern'">
    <div class="annex__card" [class.annex--modern]="appearance === 'modern'" *ngIf="showAnnexes()">
      <app-c-anexo
        [batchType]="batchType"
        [batch]="lote"
        [invoiceFile]="this.annexList[0].File"
        [appearance]="appearance"
        (handleSelectFileEvent)="onSelectFile($event)"
      ></app-c-anexo>
    </div>

    <div class="annex__actions" *ngIf="appearance === 'modern'">
      <button
        *ngIf="lotesListRef.isAndamento"
        type="button"
        class="ui-btn ui-btn--secondary"
        (click)="lotesListRef.handlerManageContracts()">
        <app-svg-icon src="assets/icons/edit-icon.svg" height="16px" color=""></app-svg-icon>
        Gerenciar contratos
      </button>

      <button type="button" class="ui-btn ui-btn--primary" (click)="lotesListRef.exportToClipboard()">
        <app-svg-icon width="13px" height="13px" color="lightGray" src="assets/icons/download-icon.svg" alt="exportar"></app-svg-icon>
        Exportar
      </button>
    </div>
  </div>

  <div
    class="listing"
    [ngClass]="{ resize: lote?.StatusOfOnlending === LotStatus.Reprovado }"
  >
    <app-detalhes-lotes-list
      #lotesListRef
      [lot]="lote"
      [typeDetail]="typeDetailLot"
      [appearance]="appearance"
    ></app-detalhes-lotes-list>
  </div>
  </ng-container>
</div>

<app-contratos-footer [link]="'/' + this.getRouteParent()"
                      [appearance]="appearance"
                      [allowIntegrationSap]="allowIntegrationSap"
                      [allowLiberacaoManual]="allowLiberacaoManual"
                      [allowReintegrationSap]="allowReintegrationSap"
                      [allowRefreshNFENumber]="allowRefreshNFENumber"
                      (refreshNFENumberEvent)="refreshNFENumber()"
                      (reSendIntegrateSapEvent)="reSendIntegrateSap()"
                      [allowCancelSap]="allowCancelSap"
                      [allowCancelAllContractsBatch]="allowCancelAllContractsBatch"
                      [integratedOnSAP]="integratedOnSAP"
                      (integrateSapEvent)="integrateSap()"
                      (cancelAllContractsBatchEvent)="handleCancelAllContractsBatchEvent($event)"
                      (viewBatchEventLogEvent)="getBatchEventLogs()"></app-contratos-footer>
